/**
 * Context-based hooks for app config access
 *
 * These hooks provide access to app configuration from StudentDataContext.
 * Grade theme is derived from the URL grade code (no API wait).
 * Learnosity loading states are managed by the useLearnosity hook, not here.
 */

import { useStudentData } from "../StudentDataContext";

/**
 * Hook to access app config state from context
 *
 * Note: gradeTheme is derived from the URL grade code and available on first
 * render. isAppLoading reflects whether header details are still being fetched.
 */
export function useAppConfigSelector() {
  const ctx = useStudentData();

  return {
    gradeTheme: ctx.gradeTheme,
    isAppLoading: ctx.headerDetailsStatus === "pending"
  };
}

/**
 * Hook for app config actions
 *
 * Note: App config state is now derived from context and URL.
 * - gradeTheme: derived from URL grade code (navigate to change)
 * - Loading states: managed by data hooks or useLearnosity
 * No manual setters are needed.
 */
export function useAppConfigDispatch() {
  // All app config state is now derived - no actions needed
  return {};
}
